import React from 'react';


export const generateLongitudeModal = ({ comments }) => (
  {
    title: 'Longitude (-180 to 180)',
    body: (
      <div>
        <div>
          Valid values:
          {' '}
          <b>-180 to 180</b>
        </div>
        <br />
        <p>
          Longitude: 0 to 180 (Eastern Hemisphere) -180 to 0 (Western Hemisphere)
        </p>
        <p>
          Events prior to 1900 were not instrumentally located, therefore, the location given is based on the latitude and longitude of the city where the maximum effects occurred.
        </p>
        {comments && (
        <p>
          {comments}
        </p>
        )}
      </div>
    ),
  }
);

export const LongitudeModal = generateLongitudeModal({});
